import { render, staticRenderFns } from "./carousel-slick.vue?vue&type=template&id=7ca6d78c&scoped=true&"
import script from "./carousel-slick.vue?vue&type=script&lang=js&"
export * from "./carousel-slick.vue?vue&type=script&lang=js&"
import style0 from "./carousel-slick.vue?vue&type=style&index=0&id=7ca6d78c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca6d78c",
  null
  
)

export default component.exports